import { render, staticRenderFns } from "./AddEmployeeToTruck.vue?vue&type=template&id=83d86b60&scoped=true"
import script from "./AddEmployeeToTruck.vue?vue&type=script&lang=js"
export * from "./AddEmployeeToTruck.vue?vue&type=script&lang=js"
import style0 from "./AddEmployeeToTruck.vue?vue&type=style&index=0&id=83d86b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d86b60",
  null
  
)

export default component.exports